module.exports = __webpack_public_path__ + "static/media/IMG_1962-min.0ca19265.JPG";